module.exports = __webpack_public_path__ + "img/logo.5018b712.png";